

import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'


export default {
components: {
Flexbox,
FlexboxItem,
XHeader,
Tabbar,
TabbarItem
},
name: 'GameCenter',

data () {
return {
list: []
}
},

methods: {
getStyleByIndex (index) {
let pos = index % 5
switch (pos) {
case 0:
return {backgroundColor: '#4169E1'}
case 1:
return {backgroundColor: '#87CEEB'}
case 2:
return {backgroundColor: '#CD853F'}
case 3:
return {backgroundColor: '#FFE4B5'}
case 4:
return {backgroundColor: '#00FFFF'}
}
return {backgroundColor: '#4169E1'}
}
},

mounted () {
this.$axios.get('/gamecenter/list').then(response => {
this.list = response.data
console.log(this.list)
}).catch(function (err) {
console.log('axios' + err)
})
}
}



// WEBPACK FOOTER //
// ./src/components/GameCenter.vue